<script>
import Modal from '../Modal.vue'

export default {
    components: {
        Modal
    },

    props: {
        jobApplicationId: {
            type: String
        },
        csrfToken: {
            type: String
        }
    },

    data() {
        return {
            confirmed: false,
            reason: ''
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
        confirm() {
            this.confirmed = true
        }
    }
}
</script>

<template>
    <modal ref="modal" heading="Withdraw Application">
        <form
            :action="`/candidate/job-applications/withdraw-application`"
            method="POST"
        >
            <input type="hidden" name="_csrfToken" :value="csrfToken" />
            <div class="mb-4" v-if="!confirmed">
                <h5>Are you sure you want to withdraw your application?</h5>
            </div>

            <div class="mb-4" v-if="confirmed">
                <input type="hidden" name="job_application_id" :value="jobApplicationId"/>
                <textarea name="reason" rows="5" :value="reason" placeholder="Please provide a reason for withdrawing your application?"></textarea>
            </div>

            <div class="grid-x grid-padding-x align-right" v-if="!confirmed">
                <div class="cell shrink">
                    <button class="button success btn-yes" type="button" @click="confirm">Yes, remove my application</button>
                </div>

                <div class="cell shrink">
                    <button class="button warning btn-no" type="button" @click="toggleModal">No, please keep my application</button>
                </div>
            </div>

            <div class="grid-x grid-padding-x align-right" v-if="confirmed">
                <div class="cell shrink">
                    <button class="button success btn-yes" type="submit" @click="submitReason">Submit</button>
                </div>
            </div>
        </form>
    </modal>
</template>